export const siteInfo = {
  name: "瓜田档案",
  fullName: "瓜田档案 · 娱乐爆料证据链观察站",
  slogans: "独家黑料 · 实锤证据链",
  tagline: "理性吃瓜，有据可依",
  intro:
    "我们把零散的爆料整理成档案：实锤截图、录音与细节逐项对应，标注出处与补充状态，让围观这件事更清楚一点。",
  email: "contact@guatian-archive.example",
  tipsEmail: "tips@guatian-archive.example",
  since: "2024 年秋",
};

export const navLinks = [
  { href: "/", label: "首页" },
  { href: "/archive", label: "爆料档案库" },
  { href: "/#evidence", label: "证据链专区" },
  { href: "/about", label: "关于我们" },
];

export const homeAnchors = [
  { id: "headline", label: "头条档案" },
  { id: "latest", label: "最新爆料" },
  { id: "evidence", label: "证据链专区" },
  { id: "rank", label: "热度榜" },
  { id: "faq", label: "常见问题" },
  { id: "tips", label: "线索投递" },
];

export const stats = [
  { value: "1,286", label: "已整理档案", note: "含已归档与补充中" },
  { value: "4,730", label: "证据条目", note: "截图 / 录音 / 细节" },
  { value: "92%", label: "标注出处比例", note: "可回溯到原始发布" },
  { value: "18", label: "编辑守则条目", note: "核对流程公开" },
];

export const principles = [
  {
    icon: "ri-search-eye-line",
    title: "先核对，再叙述",
    desc: "每条档案先做材料核对，能相互印证的部分才写成结论，其余一律标注「待补充」。",
  },
  {
    icon: "ri-links-line",
    title: "出处可查",
    desc: "截图保留原始尺寸与发布时间，录音标注对应节点，尽量不改动原始材料。",
  },
  {
    icon: "ri-scales-3-line",
    title: "给双方留位置",
    desc: "当事方的公开说明会一并收录，不因为观点不同就删减，也不替任何一方下判断。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续补充",
    desc: "档案不是一次成型，新的材料出现就追加记录，旧结论若有偏差会标注修订时间。",
  },
];

export const workflow = [
  { step: "01", title: "线索进入", desc: "读者投递或公开渠道发现，登记为待核对线索。" },
  { step: "02", title: "材料核对", desc: "逐项检查时间、出处与完整性，剔除无法溯源内容。" },
  { step: "03", title: "证据分类", desc: "按截图、录音、细节分类，标注可印证与待补充。" },
  { step: "04", title: "档案成型", desc: "整理成时间线与证据清单，公开并持续补录。" },
];

export const testimonials = [
  {
    name: "林一",
    role: "常年围观的路人",
    text: "以前吃瓜全靠切片和情绪，看完就忘。这里把时间线摆出来，谁对谁错至少自己能推一遍。",
  },
  {
    name: "周小满",
    role: "追星三年",
    text: "喜欢它不催泪也不带节奏，材料摆在那，信不信由你，这点很难得。",
  },
  {
    name: "陈默",
    role: "内容编辑",
    text: "出处标注做得比很多正经媒体还细，时间戳、原始尺寸都留着，考据党狂喜。",
  },
  {
    name: "阿野",
    role: "影视从业者",
    text: "圈里的传闻听听就好，但这份档案把通告和排班对上，确实能看出点东西。",
  },
];

export const faqs = [
  {
    q: "「独家黑料」和普通吃瓜有什么不一样？",
    a: "区别在于是否给出可核对的材料。普通吃瓜更多是转述与情绪，而本站在整理时会保留截图、录音与时间戳，并把无法印证的部分明确标出来，读者可以自己顺着材料推一遍。",
  },
  {
    q: "你们的实锤证据链是怎么整理的？",
    a: "每条档案按「线索进入 → 材料核对 → 证据分类 → 档案成型」四步走，证据按截图、录音、细节三类归档，能相互印证的写成结论，其余标注待补充，出现新材料会追加修订记录。",
  },
  {
    q: "截图和录音会保留原始出处吗？",
    a: "会。我们尽量保留原始尺寸、发布时间与对应节点，涉及第三方隐私的部分做模糊处理，但不会改动事实性的时间与内容。",
  },
  {
    q: "档案里的内容一定是真的吗？",
    a: "不保证。我们会区分「可印证」与「待补充」两种状态，并且收录当事方的公开说明。请把档案理解为一份材料清单，而不是最终判决。",
  },
  {
    q: "如果我是当事人，想补充说明怎么办？",
    a: "欢迎通过线索投递表单联系我们，注明对应档案编号即可。核实身份后，我们会把您的说明原样补入对应档案，并在时间线上标明更新时间。",
  },
  {
    q: "为什么有些档案显示「已归档」？",
    a: "当事件在一段时间内没有新材料、双方也不再公开回应时，我们会将其标记为已归档。已归档不等于结案，如有新证据仍会重新开启补充。",
  },
];

export const evidenceTypes = [
  {
    key: "截图",
    icon: "ri-image-line",
    title: "实锤截图",
    desc: "保留原始尺寸与发布时间，可回溯到首次发布位置。",
  },
  {
    key: "录音",
    icon: "ri-mic-line",
    title: "录音与口述",
    desc: "标注对应时间节点，不做变速与剪辑，保留原声片段。",
  },
  {
    key: "细节",
    icon: "ri-list-check-2",
    title: "细节比对",
    desc: "把公开口径与第三方材料逐项并排，标出矛盾点。",
  },
];